import React, { useEffect, useState } from "react";
import SideBar from "../../SideBar/SideBar";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button, DatePicker, Form, Input, Modal, Table } from "antd";
import {
  addLeadsData,
  getAllLeadsData,
  removeLeadsData,
  searchLeadsData,
  updateLeadsData,
} from "../../HttpRequest/leadsData";
import { Controller, useForm } from "react-hook-form";
import { registersuccess } from "../../SweetAlert/SweetAlert";
import { cancelButton } from "../Base UI Elements/SweetAlert";
import Pagination from "../Base UI/Pagination";

const LeadsData = () => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [data, setData] = useState([]);
  const [isFocused1, setIsFocused1] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocused3, setIsFocused3] = useState(false);
  const [isFocused4, setIsFocused4] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagedata, setPageData] = useState();
  const [pageInfo, setPageInfo] = useState({
    page: 0,
    size: 10,
  });
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    city: "",
    leadtype: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const applicationFilter = async () => {
    console.log("search data", formData);
    const response = await searchLeadsData(
      pageInfo.page,
      pageInfo.size,
      formData
    );
    setData(response.data.data);
    console.log("response->", response.data.data);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Lead Type",
      dataIndex: "leadtype",
      key: "leadtype",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Actions",
      dataIndex: "delete",
      key: "delete",
      render: (text, record) => (
        <Button
          type="link"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteClick(record);
          }}
        >
          <i
            class="fa fa-trash"
            style={{ color: "red" }}
            aria-hidden="true"
          ></i>
        </Button>
      ),
    },
  ];

  const { control, handleSubmit, reset } = useForm();

  useEffect(() => {
    fetchData();
  }, [pageInfo, selectedRow]);
  const fetchData = async () => {
    try {
      let result;
      result = await getAllLeadsData(pageInfo.page, pageInfo.size);
      console.log("get all leads result ==>", result);
      const response = result.data.data;
      console.log("get all leads ==> ", response);
      setData(response);
      setPageData(result.data.metaData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const setPageInfoData = (data) => {
    console.log("page data to parent-->", data);
    setPageInfo({
      page: data.currentPage,
      size: data.pageSize,
    });
  };

  const handleRowClick = (record) => {
    console.log("modal open data", record);
    reset(record);
    setSelectedRow(record);
    setModalVisible(true);
  };
  const handleAddClick = () => {
    reset({ pincode: "" });
    setModalVisible(true);
  };
  const handleDeleteClick = async (record) => {
    cancelButton(async (userClickedYes) => {
      if (userClickedYes) {
        try {
          console.log("delete is calling-->", record.id);
          const response = await removeLeadsData(record.id);
          console.log("delete is done...!", response);
          if (response.status === 204) {
            console.log("delete is successful!");
            fetchData();
          } else {
            console.log("data error");
          }
        } catch (error) {
          console.error("Error during delete:", error);
        }
      } else {
        console.log("User clicked No or dismissed the dialog");
      }
    });
  };
  const onSubmit = async (data) => {
    if (data.id) {
      setLoading(true);
      const response = await updateLeadsData(data.id, data);
      console.log("Lead Update response==>", response);
      if (response.status === 200) {
        setModalVisible(false);
        registersuccess("Lead Updated Successfully...");
        fetchData();
        reset();
        setLoading(false);
      }
    } else {
      setLoading(true);
      const response = await addLeadsData(data);
      if (response.status === 200) {
        setModalVisible(false);
        registersuccess("Lead Created Successfully...");
        fetchData();
        reset();
        setLoading(false);
      }
    }
  };
  const mystyle = {
    width: "90%",
    height: "2.2rem",
    borderRadius: "0.6rem",
    border: "none",
    backgroundColor: "transparent",
    outline: "none",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };
  const searchbarStyle = {
    display: "flex",
    alignItems: "center",
    borderRadius: "15rem",
    justifyContent: "end",
 
  };

  const modalContent = (
    <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
      <div className="d-flex" style={{ justifyContent: "space-between" }}>
        <div>
          <Form.Item label="Lead ID">
            <Controller
              name="leadid"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Lead Id" />}
            />
          </Form.Item>
          <Form.Item label="Lead Type">
            <Controller
              name="leadtype"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Lead Type" />
              )}
            />
          </Form.Item>
          <Form.Item label="Name">
            <Controller
              name="name"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Name" />}
            />
          </Form.Item>
          <Form.Item label="Mobile">
            <Controller
              name="mobile"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Mobile" />}
            />
          </Form.Item>
          <Form.Item label="City">
            <Controller
              name="city"
              control={control}
              render={({ field }) => <Input {...field} placeholder="City" />}
            />
          </Form.Item>
          <Form.Item label="Date">
            <Controller
              name="date"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="yyyy/mm/dd" />
              )}
            />
          </Form.Item>
        </div>
        <div>
          <Form.Item label="prefix">
            <Controller
              name="prefix"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Prefix" />}
            />
          </Form.Item>
          <Form.Item label="email">
            <Controller
              name="email"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Email" />}
            />
          </Form.Item>
          <Form.Item label="Area">
            <Controller
              name="area"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Area" />}
            />
          </Form.Item>
          <Form.Item label="Branch Area">
            <Controller
              name="brancharea"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Branch Area" />
              )}
            />
          </Form.Item>
          <Form.Item label="DNC mobile">
            <Controller
              name="dncmobile"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Type 0 or 1" />
              )}
            />
          </Form.Item>
          <Form.Item label="DNC Phone">
            <Controller
              name="dncphone"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Type 0 or 1" />
              )}
            />
          </Form.Item>
        </div>
        <div>
          <Form.Item label="Company">
            <Controller
              name="company"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Company" />}
            />
          </Form.Item>
          <Form.Item label="PinCode">
            <Controller
              name="pincode"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <Input {...field} placeholder="Pin code" />
              )}
            />
          </Form.Item>
          <Form.Item label="Branch Pin">
            <Controller
              name="branchpin"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Branch Pin" />
              )}
            />
          </Form.Item>
          <Form.Item label="Parent Id">
            <Controller
              name="parentid"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Parent Id" />
              )}
            />
          </Form.Item>
          <Form.Item label="phone">
            <Controller
              name="phone"
              control={control}
              render={({ field }) => <Input {...field} placeholder="Phone" />}
            />
          </Form.Item>
          <Form.Item label="Category">
            <Controller
              name="category"
              control={control}
              render={({ field }) => (
                <Input {...field} placeholder="Category" />
              )}
            />
          </Form.Item>
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Form.Item>
          <Button
            className={`btn btn-primary btn-block ${loading ? "loading" : ""}`}
            type="primary"
            htmlType="submit"
          >
            {loading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : selectedRow ? (
              "Update"
            ) : (
              "Create"
            )}
          </Button>
        </Form.Item>
      </div>
    </Form>
  );
  return (
    <div className="main-wrapper">
      <Header />
      <SideBar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title mt-2">Leads Data</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admindashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Leads</li>
                </ul>
              </div>
            </div>
            <div style={searchbarStyle}>
              <div style={mystyle}>
                <input
                               className={isFocused ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}

               
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                />
                <input
                  className={isFocused1 ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                
             
               
                  onFocus={() => setIsFocused1(true)}
                  onBlur={() => setIsFocused1(false)}
                />
                <input
                         className={isFocused3 ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
        
                
                  onFocus={() => setIsFocused3(true)}
                  onBlur={() => setIsFocused3(false)}
                />
                <input
                    className={isFocused4 ? "focused gridsearchinput" : "gtr gridsearchinput"}
                  type="text"
                  placeholder="Lead Type"
                  name="leadtype"
                  value={formData.leadtype}
                  onChange={handleChange}
               
                 
                  onFocus={() => setIsFocused4(true)}
                  onBlur={() => setIsFocused4(false)}
                />
              </div>
              <div
                className="searchbox"
                type="button"
                onClick={() => applicationFilter()}
              >
                <i className="fas fa-search"></i>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "2%",
                marginTop: "2%",
              }}
            >
              <Button
                type="primary"
                style={{ width: "10%" }}
                onClick={() => handleAddClick()}
              >
                Add+
              </Button>
            </div>
            <Table
              dataSource={data}
              columns={columns}
              pagination={false}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
              })}
            />
            {pagedata?.totalPages > 1 && (
              <Pagination
                pageResponce={pagedata}
                pagedataToParent={setPageInfoData}
              />
            )}
            <Modal
              title="Details"
              width={700}
              visible={modalVisible}
              onCancel={() => {
                setModalVisible(false);
                setSelectedRow(null);
              }}
              footer={false}
            >
              {modalContent}
            </Modal>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default LeadsData;
